import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Station } from '@paragon/contract-library';

export type StationsState = { [guid: string]: Station };
const initialState: StationsState = {};

const stationsSlice = createSlice({
  name: 'stations',
  initialState,
  reducers: {
    // Note that this action is used in synchronization and sometimes dispatched by DesignService, so take care when
    //   modifying it.
    loadStation: (state, action: PayloadAction<{ station: Station; setAsActive?: boolean }>) => {
      state[action.payload.station.guid] = action.payload.station;
    },
    updateCurrentProductionComponentInstanceGuid: (
      state,
      action: PayloadAction<{ stationGuid: string; currentProductionComponentInstanceGuid: string | null }>,
    ) => {
      state[action.payload.stationGuid].currentProductionComponentInstanceGuid =
        action.payload.currentProductionComponentInstanceGuid;
    },
  },
});

export const { loadStation, updateCurrentProductionComponentInstanceGuid } = stationsSlice.actions;
export const stations = stationsSlice.reducer;
